import { dispatch } from "../../utils/dispatch.js";
import { setData } from "./dom.js";
/**
 * Create Stripe card element
 *
 * @param stripe - A JS Stripe instance
 * @param cardElementNode - The card element node
 * @returns A Stripe card element
 */
export const createCard = (stripe, cardElementNode) => {
    const elements = stripe.elements({});
    const elementStyle = getComputedStyle(cardElementNode);
    const card = elements.create("card", {
        style: {
            base: {
                color: elementStyle.getPropertyValue("--color-foreground"),
            },
        },
    });
    // Handle validation on change
    card.on("change", (event) => {
        let validity = "invalid";
        let errorText = "Fyll i dina kortuppgifter";
        if (event.error) {
            errorText = event.error.message;
        }
        else if (event.complete) {
            validity = "valid";
            errorText = "";
        }
        setData(cardElementNode, "validity", validity);
        setData(cardElementNode, "errorText", errorText);
        // Trigger validation for card field
        dispatch(cardElementNode, "input");
    });
    return card;
};
/**
 * Create payment method and show possible errors.
 *
 * @param stripe - A JS Stripe instance
 * @param card - The card JS element
 * @param cardElementNode - The card element node
 * @returns Payment method and error
 */
export const createPaymentMethod = async (stripe, card, cardElementNode) => {
    const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card,
    });
    if (error) {
        setData(cardElementNode, "validity", "invalid");
        setData(cardElementNode, "errorText", error.message);
    }
    return { paymentMethod, error };
};
/**
 * Confirm card setup and show possible errors.
 *
 * @param stripe - A JS Stripe instance
 * @param card - The card JS element
 * @param cardElementNode - The card element node
 * @param clientSecret - The client secret
 * @returns Payment method and error
 */
export const confirmCardSetup = async (stripe, card, cardElementNode, clientSecret) => {
    const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
            card,
        },
    });
    if (error) {
        setData(cardElementNode, "validity", "invalid");
        setData(cardElementNode, "errorText", error.message);
    }
    return { setupIntent, error };
};
//# sourceMappingURL=stripe.js.map